import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import { Print, Save, SwipeUp, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from 'sweetalert2';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../../InputT';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Tab3 from './Tab3';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
import Datas from '../../../../../Data/Data.json';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { DemandeIjarahDto } from '../../../../../Models/DemandeIjarahDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import Tab2 from './Tab2';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import DemandeIjarah from '../Demande/Demande';

const ValidationIjarah = () => {
  // USER SESSION
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  // USER TOKEN
  const authHeader = useAuthHeader();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [modifActve, setModifActve] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [pageLoad, setPageLoad] = useState(true);
  const [data, setData] = useState<DemandeIjarahDto[]>([]);
  const navigate = useNavigate();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);
  const [datatabamort, setdatatabamort] = useState([]);
  const [document, setDocument] = useState([]);

  const loadFinancement = () => {
    localStorage.clear();
    setPageLoad(false);
    setLoading(true);
    setData([]);

    let searchClientComptes: ParamsPicklist = {
      CodeAgence: user.codage,
      Table: 'DEMAND_FINIJARA',
      Colonne1: 'EtapeActuelle',
      Colonne2: '',
      Init: 'VALIDATION_COMITE',
      Colagence: 'CODAGE',
      Choix: 34,
    };

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader(),
        CypherSearch: Crypter.encrypt(JSON.stringify(searchClientComptes)),
      },
    };
    axios
      .request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            let datas = res.Result.Table;

            if (datas.length === 0) {
              SweetAlert.fire({
                title: 'Aucune demande Ijarah en attente de validation',
                icon: 'warning',
              });
            } else {
              var newData: DemandeIjarahDto[] = [];

              datas.map((data: any, indice: number) => {
                newData.push({
                  ...data,
                  key: indice,
                  NumeroDemande: data.NumeroDemande,
                  CODAGE: data.CODAGE,
                  Numcli: data.NUMCLI,
                  NOMCLI: data.NOMCLI,
                  DateDemande: data.DateDemande
                    ? new Date(data.DateDemande.substring(0, 10)).toLocaleDateString('fr')
                    : '',
                  CodeIjara: data.CodeIjara,
                  MontantDemande: data.CoutAcquisitionDemande,
                  CODGEA: data.CODGEA,
                  CoutAchatPropose: formatNumber(data.CoutAcquisitionDemande),
                });
              });

              setData(newData);
            }
          }
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
      });
  };

  if (pageLoad) {
    loadFinancement();
  }

  const columns: ColumnsType<any> = [
    {
      title: 'Date Demande',
      dataIndex: 'DateDemande',
    },
    {
      title: 'Agence',
      dataIndex: 'CODAGE',
    },
    {
      title: 'N° Demande',
      dataIndex: 'NumeroDemande',
    },
    {
      title: 'N° Client',
      dataIndex: 'Numcli',
    },
    {
      title: 'Nom Client',
      dataIndex: 'NOMCLI',
    },
    {
      title: 'Type de Ijara',
      dataIndex: 'CodeIjara',
    },
    {
      title: 'Code Gestionnaire',
      dataIndex: 'CODGEA',
    },
    {
      title: 'Coût Achat Proposé',
      dataIndex: 'CoutAcquisitionPropose',
    },
  ];

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setModifActve(false);
    setAnnulActive(false);
    setModifActve(true);
  }

  function handleAnnulle() {
    form.resetFields();
    localStorage.clear();
    initialiazeButton();
    setdatatabamort([]);
    setGarantiesTableau([]);
  }
  const consultTypeIjarah = () => {
    if (form.getFieldValue('CodeIjara') == null) {
      SweetAlert.fire({ title: 'Svp renseigner le Code du type de Ijara', icon: 'warning' });
    } else {
      let data = Crypter.encrypt(form.getFieldValue('CodeIjara'));
      if (data.length != 0) {
        setLoading(true);
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadParamsIjarah,
          headers: {
            CypherCodeIjara: data,
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
        };
        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              console.log(res);
              if (res.StatutCode == 200) {
                const frais = res.Result.Table1[0]?.MontantFrais || 0;
                 form.setFieldValue('CodeFrais', res.Result.Table4?.map((x: any) => x.CODOPE) || []);
                form.setFieldValue('MontantFrais', frais);
                console.log(form.getFieldValue('CodeFrais'));
              } else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
          });
      }
    }
  };


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined /> Proposition
        </span>
      ),
      children: <Tab1 form={form} consultTypeIjarah={consultTypeIjarah} />,
    },

    {
      key: '2',
      label: (
        <span id='Tab'>
          <UserOutlined /> Documents
        </span>
      ),
      children: <Tab5 form={form} document={document} loading={loading}  />,
    },

    {
      key: '3',
      label: (
        <span id='Tab'>
          <ContactsOutlined /> Garanties
        </span>
      ),
      children: <Tab2 form={form} garantiesTableau={garantiesTableau} />,
    },
    {
      key: '4',
      label: (
        <span id='Tab'>
          <UsergroupAddOutlined /> Frais de Gestion
        </span>
      ),
      children: <Tab3 form={form} />,
    },
    {
      key: '5',
      label: (
        <span id='Tab'>
          <ViewAgenda /> Tableau
        </span>
      ),
      children: <Tab4 form={form} data={datatabamort} />,
    },
  ];
  function handleDemandeIjarah() {
    localStorage.setItem(Data.LocalVariable.reset, '1');
    let data = Crypter.encrypt(form.getFieldValue('NumeroDemande'));
    let numdos = form.getFieldValue('NumeroDemande');
    let dataction = Crypter.encrypt('READ_DEMANDE');

    if (data.length != 0) {
      initialiazeButton();
      setLoading(true);
      form.resetFields();
      form.setFieldValue('NumeroDemande', numdos);
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ReadFinancementIjarah,
        headers: {
          CypherNumeroDemandeIjara: data,
          CypherAction: dataction,
          Authorization: authHeader(),
          'Content-Type': 'application/json',
        },
      };
      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            console.log(res);
            if (res.StatutCode == 200) {
              // alert(JSON.stringify(res.Result.Table1[0]))
              console.log(res.Result)
              form.setFieldsValue(res.Result.Table1[0]);
              form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
              form.setFieldValue('lib_NUMCLI', res.Result.Table1[0].NOMCLI);
              // form.setFieldValue('MontantDemande', res.Result.Table1[0].MontantDemande);
              form.setFieldValue('MontantDemande', res.Result.Table1[0].CoutAcquisitionDemande);

              form.setFieldValue('CoutAcquisitionValide', res.Result.Table1[0].CoutAcquisitionDemande);
              form.setFieldValue('MargeLocativeVal', res.Result.Table1[0].MargeLocativeProp);
              form.setFieldValue('ValeurResiduelleValide', res.Result.Table1[0].ValeurResiduellePropose) 

              const garantiesRetournees: DataTypeTable[] = [];
              var newData: any = [];
              if (res.Result.Table2) {
                let montantGarantieCouvert = 0;

                res.Result.Table2.map((data: any, index: number) => {
                  montantGarantieCouvert += data.MontantCouvert;
                  garantiesRetournees.push({
                    ...data,
                    valCouvert: data.MontantCouvert,
                  });
                });
                form.setFieldValue('montantGarantieCouvert', montantGarantieCouvert);
              }

              if (res.Result.Table3) {
                res.Result.Table3.map((data: any, index: number) => {
                  newData.push({
                    ...data,
                    CapitalRembourse: formatNumber(data.CapitalRembourse),
                    CapitalRestant: formatNumber(data.CapitalRestant),
                    DateEcheance: data.DateEcheance
                      ? new Date(data.DateEcheance.substring(0, 10)).toLocaleDateString('fr')
                      : '',
                  });
                });
                setdatatabamort(newData);
              }

              let documents = [];
            if (res.Result.Table4) {
              documents = res.Result.Table4.map((doc: any) => ({
                ...doc,
                key: doc.TypeCodeDoc || doc.IdDocument,
              }));
            }
            setDocument(documents);

              setGarantiesTableau(garantiesRetournees);
              setdatatabamort(newData as any);
              consultTypeIjarah();
              initialiazeButton();
              setModifActve(false);
              setAnnulActive(false);
            } else {
              localStorage.removeItem(Data.LocalVariable.reset);
              SweetAlert.fire({ title: res.Message, icon: 'warning' });
              setSelectedRowKeys([]);
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          localStorage.removeItem(Data.LocalVariable.reset);
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: error, icon: 'error' });
          setSelectedRowKeys([]);
        });
    }
  }

  const onSelectChange = (newSelectedRowKeys: any) => {
    const requestedIndex = Array.isArray(newSelectedRowKeys) ? newSelectedRowKeys[0] : newSelectedRowKeys;
    if (requestedIndex !== undefined && data[requestedIndex]) {
      form.setFieldsValue(data[requestedIndex]);
      handleDemandeIjarah();
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  function handleValidate() {
    const demandeIjarah: DemandeIjarahDto = {
      ...form.getFieldsValue(),
      DatePremEch: formatDate(form.getFieldValue('DatePremEch')),
      CODAGE: user.codage,
      UtilVal: user.coduti,
      CodeUti: user.coduti,
    } as any;

    SweetAlert.fire({
      title:
        'Voulez-vous valider la Ijara du client : ' +
        form.getFieldValue('lib_NUMCLI') +
        ' pour la demande ' +
        form.getFieldValue('NumeroDemande') +
        ' ? ',
      showCancelButton: true,
      color: 'green',
      confirmButtonText: 'Yes',
      confirmButtonColor: 'green',
      cancelButtonColor: 'darkred',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      icon: 'question',
    }).then((res) => {
      if (res.isConfirmed) {
        performValidation(demandeIjarah, '1'); // "1" for Validate
      }
    });
  }

  function handleReject() {
    SweetAlert.fire({
      title:
        'Voulez-vous rejeter la Ijara du client : ' +
        form.getFieldValue('lib_NUMCLI') +
        ' pour la demande ' +
        form.getFieldValue('NumeroDemande') +
        ' ? ',
      input: 'textarea',
      inputPlaceholder: 'Motif du rejet...',
      showCancelButton: true,
      color: 'red',
      confirmButtonText: 'Yes',
      confirmButtonColor: 'red',
      cancelButtonColor: 'darkgreen',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      icon: 'question',
    }).then((res) => {
      if (res.isConfirmed) {
        const demandeIjarah: DemandeIjarahDto = {
          ...form.getFieldsValue(),
          DatePremEch: formatDate(form.getFieldValue('DatePremEch')),
          CODAGE: user.codage,
          UtilVal: user.coduti,
          CodeUti: user.coduti,
          MotifRejet: res.value,
        } as any;

        performValidation(demandeIjarah, '0'); // "0" for Reject
      }
    });
  }

  function performValidation(demandeIjarah: DemandeIjarahDto, action: string) {
    try {
      setLoading(true);
      setIsSubmit(true);

      let dataCrypt = Crypter.encrypt(JSON.stringify(demandeIjarah));
      let actionCrypt = Crypter.encrypt(action);

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.ValidationIjarah,
        headers: {
          Authorization: authHeader(),
          'Content-Type': 'application/json',
          Action: actionCrypt,
        },
        data: dataCrypt,
      };

      axios
        .request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;

            if (res.StatutCode == 200) {
              initialiazeButton();
              form.resetFields();
              setGarantiesTableau([]);
              setdatatabamort([]);
              loadFinancement();
              SweetAlert.fire({
                title: res.Message,
                text: res.Result,
                icon: 'success',
              });
            } else {
              SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
          SweetAlert.fire({ title: error, icon: 'error' });
        });
    } catch (error) {
      setLoading(false);
      SweetAlert.fire({
        title: 'Error occurred while processing validation',
        icon: 'error',
      });
    }
  }

  function modifButton() {
    setModifActve(true);
  }

  return (
    <div className="tab">
      <Typography align="center" className="formTitle">
        <b>VALIDATION Ijarah</b>
      </Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form
          disabled={!modifActve}
          preserve
          autoComplete="off"
          labelAlign="left"
          form={form}
          name="dynamic_form_complex"
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className="bG">
            <legend>
              <Typography color={'darkgreen'}>Actions</Typography>
            </legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={!modifActve}
                  onClick={handleValidate}
                  type="ghost"
                  htmlType="button"
                  block
                  // style={{ backgroundColor: 'green', color: 'white' }}
                >
                  Valider
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={!modifActve}
                  onClick={handleReject}
                  type="ghost"
                  htmlType="button"
                  block
                  // style={{ backgroundColor: 'red', color: 'white' }}
                >
                  Rejeter
                </Button>
                <Button size="large" className="bt_add" disabled={modifActve} onClick={modifButton} type="ghost" htmlType="button" block>
                  Modifier
                </Button>
                <Button
                  size="large"
                  disabled={annulActive}
                  onClick={handleAnnulle}
                  className="bt_add"
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Annuler
                </Button>

              </Space>
            </Form.Item>
          </div>
          <div className="clientP">
           <div>
            {/* Onglets */}
            <Tabs size="small" type="card" defaultActiveKey="1" items={items} />
           </div>

           {/* Tableau des demandes – positionné en dessous */}
           <Box sx={{ width: '85%', mt: 0 }}>
           <Spin spinning={loading}>
           <Form disabled={false}>
             <Table
              size='small'
              style={{ width: '100%' }}
              rowSelection={{ ...rowSelection, type: 'radio' }}
              columns={columns}
              dataSource={data}
              scroll={{ y: 200, x: 10 }}
              pagination={false}
             />
           </Form>
          </Spin>
        </Box>
      </div>
        </Form>
      </Spin>
    </div>
  );
};

export default ValidationIjarah;


